export default "__VITE_ASSET__ed3f6f02__"